import React from "react";
import EstimatesContent from "../components/estimates/estimates-content";

const Estimates = () => {
  return <EstimatesContent />;
};

export default Estimates;
